module.exports = __webpack_public_path__ + "static/img/2_1_5.af2b8fa8.jpg";